// extracted by mini-css-extract-plugin
var _1 = "OS8Cm";
var _2 = "Grk3t";
var _3 = "j7UqA";
export { _1 as "base", _2 as "theme-dark", _3 as "theme-light" }
